import React from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  Divider,
  Dialog,
  DialogTitle,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";

const AddDepartment = ({
  openDialog,
  handleClose,
  register,
  handleSubmit,
  errors,
  onAddEditDepartmentSubmit,
  isUpdateButton,
  isEditMode,
  setIsUpdateButton,
  setValue
}) => {
  return (
    <>
      <Dialog open={openDialog} onClose={handleClose}fullWidth={1}
        maxWidth={"xs"}>
        <DialogTitle
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>
                {!isEditMode ? "Add Department" : "Edit Department"}
              </b>
            </div>
            <GridCloseIcon
              className="pageHeader"
              onClick={handleClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 1 }}>
              <Box>
                <form>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="left"
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={12}>
                      {/* <FormLabel
                      className="stepperFormLabel" sx={{ width: "220px" }}
                      required={true}
                    >
                      Department Code
                    </FormLabel> */}
                      <TextField
                        className="stepperFormInput"
                        label="Department Code"
                        name="deptCode"
                        fullWidth
                        placeholder="Enter Department code"
                        size="small"
                        required
                        autoComplete="off"
                        {...register("deptCode", { required: true })}
                        error={Boolean(errors?.deptCode)}
                        // onChange={() => {
                        //   setError("deptCode", {
                        //     type: "manual",
                        //     message: errors?.deptCode?.message
                        //   });
                        // }}
                        helperText={errors?.deptCode?.message}
                        onChange={() => setIsUpdateButton(false)}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("deptCode", str.trim());
                         
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      {/* <FormLabel
                      className="stepperFormLabel"
                      sx={{ width: "220px" }}
                      required={true}
                    >
                      Department Name   
                    </FormLabel> */}
                      <TextField
                        className="stepperFormInput"
                        label="Department Name"
                        name="name"
                        placeholder="Enter Department name"
                        fullWidth
                        required
                        size="small"
                        autoComplete="off"
                        {...register("name", { required: true })}
                        error={Boolean(errors?.name)}
                        helperText={errors?.name?.message}
                        onChange={() => setIsUpdateButton(false)}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("name", str.trim());
                         
                        }}
                      />
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            <Divider />
            <React.Fragment>
              <Box sx={{ display: "flex", flexDirection: "row", p: 2, pl: 37 }}>
                <Box sx={{ flex: "1 1 auto" }} />
                <Button
                  variant="contained"
                  onClick={handleSubmit(onAddEditDepartmentSubmit)}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                  disabled={isUpdateButton && isEditMode}
                >
                  {!isEditMode ? "Save" : "Update"}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                >
                  Cancel
                </Button>
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default AddDepartment;
